import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

// Components
import { FullPageWidth } from '../../components/global/FullPageWidth/FullPageWidth';
import { BillboardBannerAd } from '../../components/global/Ads/BillboardBannerAd';

// Helpers
import { getAdData } from '../../utils/adHelpers';

const SbSharedBillboardAdComponent = ({ itemSearch, adWidth }) => {
    const { displayUriRef } = itemSearch;
    const billboardAdData = get(getAdData(displayUriRef, 'billboard'), adWidth);

    if (!billboardAdData) {
        return null;
    }

    return (
        <FullPageWidth>
            <BillboardBannerAd {...billboardAdData} />
        </FullPageWidth>
    );
};

SbSharedBillboardAdComponent.defaultProps = {
    adWidth: 'mobile',
};

SbSharedBillboardAdComponent.propTypes = {
    itemSearch: PropTypes.object.isRequired,
    adWidth: PropTypes.string.isRequired,
};

export const SbSharedBillboardAd = createFragmentContainer(SbSharedBillboardAdComponent, {
    itemSearch: graphql`
        fragment SbSharedBillboardAd_itemSearch on ItemSearchQueryConnection {
            displayUriRef
        }
    `,
});
